import React, { lazy } from "react";

import { VIEW_SETTINGS_GROUPS } from "constants/permissions";

const RolePage = lazy(() => import("./RolePage"));

const roleRoute = {
  path: "system.role",
  element: <RolePage />,
  root: false,
  permission: VIEW_SETTINGS_GROUPS,
};

export default roleRoute;
